import { motion } from "framer-motion";
import { AGNES } from "@/lib/images";

const stats = [
  { value: "107", label: "Years of life" },
  { value: "5", label: "Generations of family" },
  { value: "2", label: "Royal letters received" },
  { value: "∞", label: "Hearts she's touched" },
];

export default function CenturyIntro() {
  return (
    <section className="relative bg-sand py-24 md:py-32">
      <div className="mx-auto max-w-4xl px-5 text-center">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-hand text-3xl text-terracotta">More than a number…</p>
          <h2 className="mt-2 font-serif text-4xl font-bold tracking-tight text-forest md:text-5xl">
            107 Years of <span className="italic text-terracotta">Living</span> History
          </h2>
        </motion.div>

        {/* Photo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="relative mx-auto mt-12 max-w-sm"
        >
          <div className="overflow-hidden rounded-[2rem] border-[10px] border-cream shadow-2xl">
            <img src={AGNES.sunglasses} alt="Agnes Murphy" className="aspect-[4/5] w-full object-cover" />
          </div>
          <div className="absolute -bottom-5 -right-4 rounded-2xl bg-terracotta px-7 py-5 text-cream shadow-xl">
            <p className="font-serif text-4xl font-bold leading-none">107</p>
            <p className="text-xs uppercase tracking-widest">years young</p>
          </div>
        </motion.div>

        {/* Description */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mx-auto mt-10 max-w-2xl leading-relaxed text-forest/75 md:text-lg"
        >
          Born in an era of profound change, Agnes has witnessed over a century of history
          unfold. She has been a pillar of strength, a wellspring of joy, and a matriarch whose
          love stretches across generations — her spirit as vibrant today as it ever was.
        </motion.p>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-border bg-border sm:grid-cols-4"
        >
          {stats.map((s) => (
            <div key={s.label} className="bg-cream p-6 text-center">
              <p className="font-serif text-4xl font-bold text-terracotta">{s.value}</p>
              <p className="mt-1 text-sm text-forest/60">{s.label}</p>
            </div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}
